__turbopack_context__.v({
  "active": "b9P_CW_active",
  "alternateMobile": "b9P_CW_alternateMobile",
  "bookCallRoot": "b9P_CW_bookCallRoot",
  "chatbotContainer": "b9P_CW_chatbotContainer",
  "chatbotToggleButton": "b9P_CW_chatbotToggleButton",
  "crossbtn": "b9P_CW_crossbtn",
  "root": "b9P_CW_root",
});
